import React, { useEffect, useState } from 'react';
import { useReveal } from '../lib/useReveal';
export function FinalCTASection() {
  const [ref, vis] = useReveal();
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) return 15 * 60;
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <section className="bg-brand-alternate py-8 md:py-10 px-4 sm:px-6 border-t border-brand-border-soft" data-id="element-116">
      <div className="container mx-auto max-w-3xl" data-id="element-117">
        <div ref={ref} className={`reveal text-center ${vis ? 'is-visible' : ''}`} data-id="element-118">
          <div className="mb-5 flex justify-center items-center gap-2 text-brand-cta font-bold text-lg md:text-xl tracking-widest uppercase" data-id="element-119">
            <span data-id="element-120">⏰ EL PRECIO CIERRA EN:</span>
            <span className="font-serif bg-white px-3 py-1 rounded border border-brand-border-soft shadow-sm" data-id="element-121">
              {hours.toString().padStart(2, '0')} hs :{' '}
              {minutes.toString().padStart(2, '0')} min :{' '}
              {seconds.toString().padStart(2, '0')} seg
            </span>
          </div>

          <div className="space-y-4 mb-6" data-id="element-122">
            {/* Premium Compact */}
            <div className="bg-brand-footer border-2 border-brand-accent rounded-[20px] p-6 text-left relative overflow-hidden shadow-premium" data-id="element-123">
              <div className="absolute top-0 right-0 bg-brand-cta text-white font-bold text-[10px] px-3 py-1 rounded-bl-lg uppercase tracking-wider" data-id="element-124">
                ⭐ RECOMENDADO
              </div>
              <h3 className="text-xl md:text-2xl font-serif font-bold text-white mb-1 pr-24" data-id="element-125">
                🏆 MEGAPACK CÓDIGO FÉRTIL + KIT RITUAL PREMIUM
              </h3>
              <p className="text-brand-border-soft font-bold text-sm mb-4" data-id="element-126">
                6 Tomos + 6 Bonos + Kit Ritual Premium de 60 páginas
              </p>
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-127">
                <div className="flex items-center gap-3" data-id="element-128">
                  <span className="text-white/50 line-through text-lg font-bold" data-id="element-129">
                    $89.000
                  </span>
                  <p className="text-3xl font-extrabold text-white leading-none" data-id="element-130">
                    $27.990 <span className="text-sm text-white/80" data-id="element-131">ARS</span>
                  </p>
                </div>
                <a href="https://academiaholisticaargentina.com/cart/48663037083865:1" target="_blank" rel="noopener noreferrer" className="inline-block py-3 px-6 rounded-full text-white font-bold text-sm tracking-widest uppercase text-center transition-all bg-brand-cta hover:bg-brand-cta-hover shadow-medium hover:-translate-y-1" data-id="element-132">
                  → QUIERO EL MEGAPACK + KIT PREMIUM
                </a>
              </div>
            </div>

            {/* Base Compact */}
            <div className="bg-brand-card border border-brand-border-soft rounded-[20px] p-6 text-left shadow-soft" data-id="element-133">
              <h3 className="text-xl md:text-2xl font-serif font-bold text-brand-heading mb-1" data-id="element-134">
                📘 MEGAPACK CÓDIGO FÉRTIL
              </h3>
              <p className="text-brand-subheading font-bold text-sm mb-4" data-id="element-135">
                6 Tomos + 6 Bonos
              </p>
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-136">
                <div className="flex items-center gap-3" data-id="element-137">
                  <span className="text-brand-soft line-through text-lg font-bold" data-id="element-138">
                    $69.000
                  </span>
                  <p className="text-3xl font-extrabold text-brand-heading leading-none" data-id="element-139">
                    $19.990{' '}
                    <span className="text-sm text-brand-subheading" data-id="element-140">ARS</span>
                  </p>
                </div>
                <a href="https://academiaholisticaargentina.com/cart/48663034200281:1" target="_blank" rel="noopener noreferrer" className="inline-block py-3 px-6 rounded-full text-brand-heading font-bold text-sm tracking-widest uppercase text-center transition-all bg-white hover:bg-brand-primary border border-brand-border-soft hover:border-brand-accent hover:-translate-y-1" data-id="element-141">
                  → QUIERO MI MEGAPACK
                </a>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-brand-subheading text-xs sm:text-sm font-medium" data-id="element-142">
            <span className="flex items-center gap-1.5" data-id="element-143">
              🔒 Pago 100% seguro
            </span>
            <span className="flex items-center gap-1.5" data-id="element-144">
              ⚡ Acceso en 5 minutos
            </span>
            <span className="flex items-center gap-1.5" data-id="element-145">
              🛡️ Garantía 7 días
            </span>
            <span className="flex items-center gap-1.5" data-id="element-146">
              💳 Mercado Pago | Tarjeta | Transferencia
            </span>
          </div>
        </div>
      </div>
    </section>;
}